import { NsProgress } from 'components/common/ns-progress/NsProgress';
import { NsBackCta } from 'components/common/ns-back-cta/NsBackCta';
import { NsContent } from 'components/common/ns-content/NsContent';

export const directDebitHeaderTestId = 'directDebitHeaderTestId';

export const DirectDebitHeader = () => {
  return (
    <NsContent data-testid={directDebitHeaderTestId}>
      <NsBackCta />
      <NsProgress />
      <h1 id="paymentDetails">Payment details</h1>
      <h5>Almost there...</h5>
    </NsContent>
  );
};

export default DirectDebitHeader;
